<template>
  <div style="flex: 1;background: #fff;">
    <div class="chat-box container">
      <Tabs @on-click="refresh" v-model="tabSelect" :animated="false">
          <TabPane name="saleafter" label="售后">
            <Saleafter ref="saleafterElem"></Saleafter>
          </TabPane>
          <TabPane name="presales" label="售前">
            <Presales ref="presalesElem"></Presales>
          </TabPane>
          <TabPane name="comment" label="差评">
            <Comment ref="commentElem"></Comment>
          </TabPane>
      </Tabs>
    </div>
  </div>
  
</template>
<script>
import Saleafter from "./components/saleafter.vue";
import Presales from "./components/presales.vue";
import Comment from "./components/comment.vue";
import RequestUtils from "@/utils/RequestUtils";
import conf from "@/views/im/conf";

export default {
  components: {
    Saleafter,
    Presales,
    Comment
  },

  data() {
    return {
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      tabSelect: 'saleafter',
      searchfield: 'name',
      searchval: '',
      filter: {
        connector: 'lazada'
      },
      columns: [
          {
              title: '店铺名',
              key: 'name'
          },
          {
              title: '账号',
              key: 'account'
          },
          {
              title: '国家',
              key: 'country_text'
          },
          {
              title: '创建时间',
              key: 'created_at'
          },
          {
              title: '授权失效时间',
              key: 'im_expiresin_text'
          },
          {
              title: 'Action',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },

  methods: {
    authorize () {
      let param = new FormData();
      param.set("appcate", 'IM');

      RequestUtils.request(conf.getAuthUrl(this.filter.connector), param)
      .then(data => {      
        window.open(data.url,"Add Account", "width=1024,height=600,toolbar=no,location=no,directories=no,status=no,menubar=yes,scrollbars=yes");
      })
    },
    selectitem (key, value) {
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let filter = JSON.parse(JSON.stringify(this.filter));
      if (this.searchval) {
        filter[this.searchfield] = this.searchval;
      }
      let param = new FormData();
      param.set("limit", this.pageSize);
      param.set("offset", (this.curPage-1)*this.pageSize );
      param.set("filter", JSON.stringify(filter) );
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getStorePageUrl(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.rows;
        self.loading = false;
      })
    },
    refresh(name) {
      name = name ? name : this.tabSelect;
      if (name == 'saleafter') {
        this.$refs.saleafterElem.request();
      } else if (name == 'presales') {
        this.$refs.presalesElem.request();
      } else if (name == 'comment') {
        this.$refs.commentElem.request();
      }
    }
  },

  created() {
    this.request();
  }
};
</script>
<style type="text/css">
  .ivu-tabs-nav .ivu-tabs-tab {
    padding: 20px 16px!important;
  }
</style>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.ivu-tabs-nav {
  .ivu-tabs-tab {      
    padding: 20px 16px!important;
  }
}

.panel-box {
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .container {
  }

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
